
export default {
  data () {
    return {
      boaAffiliates: [],
      selectedBoaAffiliates: [],
      loading: false,
      levels: [
        `premier-partner-exclusive`,
        `premier-partner`,
        `partner`,
        `member`,
        `affiliate`,
      ],
    };
  },
  mounted () {
    this.$nextTick(async () => {
      this.boaAffiliates = await this.getAffiliates();
      this.selectedBoaAffiliates = [...this.boaAffiliates];
    });
  },
  methods: {
    // INTERFACES:
    updateSelectedBoaAffiliates (selectedOffers) {
      this.selectedBoaAffiliates = selectedOffers;
    },
    // ABSTRACTION BARRIER:
    async getAffiliates () {
      this.loading = true;
      const queryParams = {
        fields: `id,title,slug,acf,image,terms`,
        posts: {
          post_type: `boa-affiliates`,
          posts_per_page: 300,
          post_status: `publish`,
          orderby: `menu_order`,
          order: `DESC`,
        },
        options: {
          image_size: `medium_large`,
          taxonomy: `boa_cat`,
        },
      };
      const request = await this.$getPosts(`/posts`, queryParams).catch(
        _ => null,
      );

      this.loading = false;

      if (!request) return;
      return request;
    },
    combineCategories (categories) {
      // return categories.map(category => category.id).join(`, `);
    }, // TODO: merge with duplicate method on BOAOffers.vue
    getAffiliatesByLevel (affiliates, level) {
      return affiliates.filter(affiliate => affiliate.acf.affiliate_level === level);
    },
  },
};
